import { render, staticRenderFns } from "./seamlesslotto.vue?vue&type=template&id=18505344&scoped=true&"
import script from "./seamlesslotto.vue?vue&type=script&lang=js&"
export * from "./seamlesslotto.vue?vue&type=script&lang=js&"
import style0 from "./seamlesslotto.vue?vue&type=style&index=0&id=18505344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18505344",
  null
  
)

export default component.exports